import { StoreCogOutlineIcon } from './StoreCogOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E6D19187-D3DA-42DE-B61F-AF703112D8E3
 * name store-cog-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-cog-outline.svg
 * tags
 * - Places 
 * - Shopping 
 * - Settings 
 */
export const ShopSettingsOutlineIcon = StoreCogOutlineIcon;
export default ShopSettingsOutlineIcon